import BaseApi from "@/core/HttpResources/BaseApi";
import ProposalMember from '../models/porposal/porposalMembers.model';
export default class PorposalMemberService {
  baseApiPublish = new BaseApi("PorposalMembers");


  async getQuantity(annoucementId:number,id: number) {
    var baseApi = new BaseApi("PorposalMembers/getQuantityTimeInvestigator/"+id+"/annoucementId/"+annoucementId);
    return new Promise<ProposalMember>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
}
